import React, { useEffect, useState } from "react";
import { Download, X, Share } from "lucide-react";
import { useLang } from "@/i18n";

const KEY = "garage_pwa_dismissed";

/** "Installeer als app" banner: uses the native prompt on Android/Chrome, shows iPad/Safari instructions otherwise. */
export default function InstallAppBanner() {
  const { t } = useLang();
  const [prompt, setPrompt] = useState(null);
  const [show, setShow] = useState(false);
  const standalone = window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1);

  useEffect(() => {
    if (standalone || localStorage.getItem(KEY)) return;
    const onPrompt = (e) => { e.preventDefault(); setPrompt(e); setShow(true); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    if (isIOS) setShow(true);
    return () => window.removeEventListener("beforeinstallprompt", onPrompt);
  }, [standalone, isIOS]);

  if (!show) return null;
  const dismiss = () => { localStorage.setItem(KEY, "1"); setShow(false); };
  const install = async () => {
    if (!prompt) return;
    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    if (outcome === "accepted") setShow(false);
  };

  return (
    <div className="fixed bottom-4 inset-x-4 sm:inset-x-auto sm:right-4 sm:w-[380px] z-50 rounded-xl border border-primary/40 bg-slate-950 text-slate-100 shadow-2xl p-4" data-testid="install-app-banner">
      <button onClick={dismiss} className="absolute top-2 right-2 text-slate-400 hover:text-white" aria-label={t("close")} data-testid="install-app-dismiss"><X className="h-4 w-4" /></button>
      <div className="flex items-start gap-3">
        <img src="/icon-192.png" alt="" className="h-12 w-12 rounded-xl shrink-0" />
        <div className="min-w-0">
          <div className="font-semibold text-sm">{t("installAppTitle")}</div>
          {prompt ? (
            <>
              <p className="text-xs text-slate-300 mt-0.5">{t("installAppBody")}</p>
              <button onClick={install} className="mt-3 inline-flex items-center gap-2 rounded-full bg-primary text-primary-foreground px-4 py-2 text-sm font-medium" data-testid="install-app-button"><Download className="h-4 w-4" />{t("installAppButton")}</button>
            </>
          ) : (
            <p className="text-xs text-slate-300 mt-0.5 leading-relaxed">{t("installAppIosHint")} <Share className="inline h-3.5 w-3.5 -mt-0.5" /> → <strong>{t("installAppIosAdd")}</strong></p>
          )}
        </div>
      </div>
    </div>
  );
}
